__turbopack_context__.v({
  "priceRoot": "PlpFiltersRange-module-scss-module__199xWW__priceRoot",
  "rangeToggle": "PlpFiltersRange-module-scss-module__199xWW__rangeToggle",
  "rangeToggleActive": "PlpFiltersRange-module-scss-module__199xWW__rangeToggleActive",
  "rangeToggleContainer": "PlpFiltersRange-module-scss-module__199xWW__rangeToggleContainer",
  "rangeToggleInactive": "PlpFiltersRange-module-scss-module__199xWW__rangeToggleInactive",
  "root": "PlpFiltersRange-module-scss-module__199xWW__root",
  "selectRange": "PlpFiltersRange-module-scss-module__199xWW__selectRange",
});
